(function () {
  'use strict';

  var TOPICS = ['variant-change', 'variant-cto-change'];
  var DEBOUNCE_MS = 150;

  var debounceTimer = null;
  var lastKey = null;

  function az() {
    return window.analyzify || null;
  }

  function log(message, extra) {
    var a = az();
    if (a && typeof a.log === 'function') a.log(message, 'analyzify-variant-bridge', extra || 'run');
    else if (window.console && console.warn) console.warn('[analyzify-variant-bridge]', message);
  }

  function waitFor(test, tries, interval) {
    return new Promise(function (resolve) {
      var n = 0;
      (function tick() {
        if (test()) return resolve(true);
        if (++n >= tries) return resolve(false);
        setTimeout(tick, interval);
      })();
    });
  }

  function price(cents) {
    var a = az();
    if (a && typeof a.formatPrice === 'function') return a.formatPrice(cents, true);
    var n = Number(cents);
    return isNaN(n) ? 0 : Math.round(n) / 100;
  }

  function resolveVariantId(payload) {
    var v = payload && payload.data && payload.data.variant && payload.data.variant.id;
    return v != null ? String(v) : null;
  }

  function pickVariant(product, variantId) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (variantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === variantId) return product.variants[i];
      }
    }
    return product.variants[0];
  }

  function send(product, variant) {
    var a = az();
    if (!a) return;

    var payload = {
      variant_id: variant.id != null ? String(variant.id) : null,
      variant_title: variant.title || null,
      product_price: price(variant.price),
      product_sku: variant.sku || null,
      product_id: product.id != null ? String(product.id) : null,
      product_title: product.title || null,
      cart_id: a.cart_id || null,
      variant_availability: !!variant.available
    };

    var G = a.properties && a.properties.GA4;
    if (G && G.status && typeof window.gtag === 'function') {
      if (G.primary && G.primary.status && G.primary.id && G.primary.events && G.primary.events.variant_changed) {
        window.gtag('event', 'variant_changed', Object.assign({}, payload, { send_to: G.primary.id }));
      }
      if (G.secondary && G.secondary.status && G.secondary.id && G.secondary.events && G.secondary.events.variant_changed) {
        window.gtag('event', 'variant_changed', Object.assign({}, payload, { send_to: G.secondary.id }));
      }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: 'ee_variant_changed',
      ss_event_id: (a.eventId && typeof a.eventId.get === 'function' && a.eventId.get('variant_changed')) || null
    }, payload));

    log(payload, 'send');
  }

  function run(payload) {
    var url = location.pathname.replace(/\/$/, '') + '.js';

    waitFor(function () {
      var a = az();
      return !!(a && a.properties && a.properties.GA4);
    }, 30, 100)
      .then(function () {
        return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      })
      .then(function (res) {
        if (!res || !res.ok) throw new Error('product fetch failed: ' + (res && res.status));
        return res.json();
      })
      .then(function (product) {
        var variant = pickVariant(product, resolveVariantId(payload));
        if (!variant) return;

        var key = String(product.id) + ':' + String(variant.id);
        if (key === lastKey) return;
        lastKey = key;

        send(product, variant);
      })
      .catch(function (err) {
        log('error: ' + (err && err.message ? err.message : err));
      });
  }

  function handle(topic, payload) {
    log({ event: topic, data: payload && payload.data }, 'pubsub');
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { run(payload); }, DEBOUNCE_MS);
  }

  function init() {
    if (typeof window.subscribe !== 'function') return false;
    TOPICS.forEach(function (topic) {
      window.subscribe(topic, function (payload) { handle(topic, payload); });
    });
    return true;
  }

  if (!init()) {
    waitFor(function () { return typeof window.subscribe === 'function'; }, 50, 100).then(function (ok) {
      if (ok) init();
    });
  }
})();